import {autoinject} from "aurelia-dependency-injection";
import {computedFrom} from "aurelia-framework";
import {
    type VesselComparisonDetails,
} from "../../../../../models/vessel-comparison/vessel-comparison.models";
import {EntityTypeConfigurationHelper, EntityTypeConfigurationModel} from "../../../../../models/basics/basics.models";

@autoinject()
export class VesselComparisonVesselOptionVm {

    private _selectedVessel: VesselComparisonDetails;
    vesselId: number;

    @computedFrom("_selectedVessel")
    get selectedVessel(): VesselComparisonDetails {
        return this._selectedVessel;
    }

    set selectedVessel(value: VesselComparisonDetails) {
        this._selectedVessel = value;
    }
    
    constructor(carbonCalculatorVesselDetails: VesselComparisonDetails, 
                private entityTypeConfigurationHelper: EntityTypeConfigurationHelper,
                private reloadFunc: (vesselId: number, index) => void) {
        this.selectedVessel = carbonCalculatorVesselDetails;
    }
    
    get entityTypes(): EntityTypeConfigurationModel[] {
        return this.entityTypeConfigurationHelper.getConfigurationByKey(["AllVesselSearch"]).filter(x => x.key == "AllVesselSearch");
    }
    
    public searchVesselSelected($event, index: number, vesselId: number = null) {
        if($event && $event.detail.selectedEntity)
            this.reloadFunc($event.detail.selectedEntity.id, index);

        if(vesselId != null) {
            this.vesselId = vesselId;
            this.reloadFunc(vesselId, index);
        }
    }
}